import { render, staticRenderFns } from "./list-reward.vue?vue&type=template&id=7d1cfd5e&"
import script from "./list-reward.vue?vue&type=script&lang=js&"
export * from "./list-reward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports